export default "__VITE_ASSET__On7Cw6hy__"